import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormControlLabel,
  Checkbox,
  Typography
} from '@mui/material';
import {
  fetchProperties,
  selectProperties,
  selectGlobalProperty,
  setGlobalProperty,
  selectPropertyStatus,
  setLockProperty,
  selectIsPropertyLocked,
   selectGatewayType,
} from '../redux/propertySlice';

const PropertyDropdown = () => {
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const globalProperty = useSelector(selectGlobalProperty);
  const isPropertyLocked = useSelector(selectIsPropertyLocked);
  const userId = sessionStorage.getItem('UserId');
  const status = useSelector(selectPropertyStatus);
const gatewayType = useSelector(selectGatewayType);
  useEffect(() => {
    const savedLockState = localStorage.getItem('propertyLocked');
    const savedPropertyId = localStorage.getItem('selectedPropertyId');
    
    if (savedLockState === 'true') {
      dispatch(setLockProperty(true));
    }
    
    if (savedPropertyId && savedLockState === 'true') {
      dispatch(setGlobalProperty(savedPropertyId));
    }
  }, [dispatch]);

  useEffect(() => {
    if (userId && status === 'idle') {
      dispatch(fetchProperties(userId));
    }
  }, [dispatch, userId, status]);

  const handleChange = (event) => {
    const selectedId = event.target.value;
    dispatch(setGlobalProperty(selectedId));

    if (isPropertyLocked) {
      localStorage.setItem('selectedPropertyId', selectedId);
    }
  };

  const handleLockToggle = (event) => {
    const isChecked = event.target.checked;
    dispatch(setLockProperty(isChecked));
    
    if (isChecked) {
      localStorage.setItem('propertyLocked', 'true');
      if (globalProperty) {
        localStorage.setItem('selectedPropertyId', globalProperty);
      }
    } else {
      localStorage.removeItem('propertyLocked');
      localStorage.removeItem('selectedPropertyId');
    }
  };

  const selectedProperty = properties.find(p => p.Id === globalProperty);

  return (
    <Box sx={{ 
      minWidth: 200, 
      mr: 1, 
      display: 'flex', 
      alignItems: 'center', 
      gap: 1 
    }}>
        <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        backgroundColor: isPropertyLocked ? '#4caf50' : 'transparent',
        padding: '1px 3px',
        borderRadius: '4px',
        border: '1px solid rgba(255, 255, 255, 0.3)'
      }}>
        <Checkbox
          checked={isPropertyLocked}
          onChange={handleLockToggle}
          size="small"
          sx={{
            color: 'white',
            padding: '1px',
            '&.Mui-checked': {
              color: 'white',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '18px'
            }
          }}
        />
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'white', 
            fontSize: '0.85rem',
            fontWeight: 500,
            whiteSpace: 'nowrap'
          }}
        >
          Save
        </Typography>
      </Box>
      <FormControl 
        fullWidth 
        size="small" 
        variant="filled" 
        className="custom-textfield" 
        sx={{
          background: 'white',
          borderRadius: '4px',
          flex: 1
        }}
      >
        <InputLabel 
          id="property-select-label"
          sx={{ color: '#635bff' }}
        >
          Property
        </InputLabel>
        <Select
          labelId="property-select-label"
          id="property-select"
          value={globalProperty || ''}
          label="Property"
          onChange={handleChange}
          disabled={isPropertyLocked}
          sx={{
            backgroundColor: 'white',
            borderRadius: '4px',
            height: '35px',
            '& .MuiSelect-select': {
              paddingTop: '12px',
              paddingBottom: '12px'
            },
            '&.Mui-disabled': {
              backgroundColor: '#f0f0f0',
              opacity: 0.8
            }
          }}
        >
          {properties.map((property) => (
            <MenuItem key={property.Id} value={property.Id}>
              {property.Name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    
    </Box>
  );
};

export default PropertyDropdown;